import { useData } from './useData';

export enum UserPermissions {
    accessMerchantAreas = 'accessMerchantAreas',
}

export const usePermissionChecker = () => {
    const { login } = useData();

    const permissions = login?.data?.permissions as Record<UserPermissions, boolean> | undefined;

    return {
        can: (permission: UserPermissions) => {
            if (permissions === undefined) {
                return null;
            }
            return permissions[permission] === true;
        },
    };
};
